import { DASHBOARD } from '../constant/actionTypes';

const getDashboardData = (state, action) => {
  switch (action.type) {
    case DASHBOARD.USER.INITIATE:
      return { isFetching: false };
    case DASHBOARD.USER.SUCCESS:
      return { isFetching: true, data: action.payload };
    case DASHBOARD.USER.ERROR:
      return action.payload;
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getDashboardData;
